import { AxiosResponse } from "axios";
import { PaginationResponse } from "@/main/models/common/paginationResponse";
import { HolidaySaveRequest, HolidaysRequest } from "@/main/models/request/holidaysRequest";
import { HolidaysResponse } from "@/main/models/response/holidaysResponse";
import { Result } from "@/main/models/common/resultResponse";

export abstract class IHolidaysApi {
	abstract getSearchGrid(request: HolidaysRequest): Promise<AxiosResponse<PaginationResponse<HolidaysResponse[]>>>;

	abstract saveHoliday(request: HolidaySaveRequest): Promise<AxiosResponse<Result<HolidaysResponse>>>;

	abstract changeStatusHoliday(request: HolidaySaveRequest): Promise<AxiosResponse<Result<void>>>;
}
